var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organisation-add',{attrs:{"show":_vm.showOrganisationAdd,"title":'Set up an organisation to continue',"closable":false},on:{"added":_vm.added}})}
var staticRenderFns = []

export { render, staticRenderFns }